import { AlertTriangle, ArrowDownToLine } from "lucide-react";

import { nf, pf, type NumeriRiga } from "@/lib/panoramica";
import { cn } from "@/lib/utils";

interface StrisciaTotaliProps {
  buybox: NumeriRiga;
  priceSetter: NumeriRiga;
}

interface Voce {
  etichetta: string;
  valore: string;
  sotto?: string;
  perdita?: boolean;
  floor?: boolean;
}

export function StrisciaTotali({ buybox, priceSetter }: StrisciaTotaliProps): JSX.Element {
  const sottoMargine = buybox.sotto_margine + priceSetter.sotto_margine;
  const voci: Voce[] = [
    { etichetta: "Offerte", valore: nf(buybox.offerte + priceSetter.offerte) },
    { etichetta: "% vinte", valore: buybox.vinte_pct === null ? "—" : pf(buybox.vinte_pct), sotto: "solo buybox" },
    { etichetta: "Recuperabili", valore: nf(buybox.recuperabili), sotto: `${nf(buybox.recuperabili_auto)} in auto` },
    { etichetta: "Al limite", valore: nf(buybox.al_limite) },
    { etichetta: "Attaccate al floor", valore: nf(buybox.attaccate_al_floor), floor: buybox.attaccate_al_floor > 0 },
    { etichetta: "Sotto margine", valore: nf(sottoMargine), perdita: sottoMargine > 0 },
    { etichetta: "Spente", valore: buybox.spente === null ? "—" : nf(buybox.spente) },
    { etichetta: "Dati mancanti", valore: nf(buybox.dati_mancanti + priceSetter.dati_mancanti) },
  ];
  return (
    <div>
      {/* Le cifre del giorno: fogli bianchi separati da un filo (gap-px sul fondo linea). */}
      <dl
        aria-label="Totali dei canali mostrati"
        className="grid grid-cols-2 gap-px overflow-hidden rounded-[var(--radius-lg)] border border-line bg-line sm:grid-cols-4 xl:grid-cols-8"
      >
        {voci.map((v) => (
          <div
            key={v.etichetta}
            className="flex min-w-0 flex-col gap-1.5 bg-card px-4 pb-3.5 pt-3"
          >
            <dt className="truncate text-label text-ink-3">{v.etichetta}</dt>
            <dd className="flex items-baseline gap-1.5">
              {v.perdita ? <AlertTriangle className="h-3.5 w-3.5 self-center text-danger" strokeWidth={2} aria-hidden="true" /> : null}
              {v.floor ? <ArrowDownToLine className="h-3.5 w-3.5 self-center text-ink-3" strokeWidth={2} aria-hidden="true" /> : null}
              <span className={cn("font-mono text-xl font-semibold leading-none tabular-nums", v.perdita ? "text-danger" : "text-ink")}>
                {v.valore}
              </span>
              {v.sotto ? <span className="whitespace-nowrap text-micro tabular-nums text-ink-3">{v.sotto}</span> : null}
            </dd>
          </div>
        ))}
      </dl>
      <p className="mt-1.5 text-label text-ink-3">Conteggi di offerte: un prodotto venduto su 3 canali conta 3.</p>
    </div>
  );
}
